import React from 'react';
import StudyAbroad from '../section/StudyAbroad';
import PageTransition from '../components/PageTransition';

const StudyAbroadPage = () => {
  return (
    <PageTransition>
      <StudyAbroad />
    </PageTransition>
  );
};

export default StudyAbroadPage;
